import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setDoorCompleted } from 'shared/thunks';
import { EUserStatus, TUserState } from 'shared/types/user';

const initialState: TUserState = { user: null, status: EUserStatus.Init };

const userSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(setDoorCompleted.pending, state => {
        state.status = EUserStatus.Loading;
      })
      .addCase(setDoorCompleted.fulfilled, (state, action: PayloadAction<{ points: number; doorId: number }>) => {
        state.status = EUserStatus.Success;

        if (state.user) {
          state.user.doors.forEach(door => {
            if (door.id === action.payload.doorId) {
              door.status = true;
            }
          });

          state.user.points = action.payload.points;
        }
      })
      .addCase(setDoorCompleted.rejected, state => {
        state.status = EUserStatus.Failed;
      });
  },
  initialState,
  name: 'user',
  reducers: {},
});

export const { reducer: userReducer } = userSlice;
